import { render, staticRenderFns } from "./FaultBreakdownWidget.vue?vue&type=template&id=2483b8c5&"
import script from "./FaultBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./FaultBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports